module.exports = __webpack_public_path__ + "static/media/bck2.0cfb83a1.mp3";